// skills/crafting/craftingData.js
// Crafting skill configuration - Jewelry and Armor crafting

export const TOOLS = {
    NEEDLE: {
        id: 'needle',
        name: 'Needle',
        level: 1,
        speedMultiplier: 1.0,
        price: 0
    },
    PYRESTONE_NEEDLE: {
        id: 'pyrestone_needle',
        name: 'Pyrestone Needle',
        level: 10,
        speedMultiplier: 1.15,
        price: 1000
    },
    BLACKIRON_NEEDLE: {
        id: 'blackiron_needle',
        name: 'Blackiron Needle',
        level: 25,
        speedMultiplier: 1.3,
        price: 5000
    },
    PALE_SHARD_NEEDLE: {
        id: 'pale_shard_needle',
        name: 'Pale Shard Needle',
        level: 40,
        speedMultiplier: 1.5,
        price: 25000
    },
    SKYIRON_NEEDLE: {
        id: 'skyiron_needle',
        name: 'Skyiron Needle',
        level: 55,
        speedMultiplier: 1.7,
        price: 100000
    },
    VERDANT_NEEDLE: {
        id: 'verdant_needle',
        name: 'Verdant Needle',
        level: 70,
        speedMultiplier: 2.0,
        price: 250000
    }
};

// Jewelry - crafted from gems + gold bars (+ spun fiber for pendants)
// Bands = ring slot (attack, spell damage, defense, crit at higher tiers)
// Pendants = neck slot (speed, defense, accuracy at higher tiers)
export const JEWELRY = {
    // Bands - gem + gold bar - Ring slot
    SAPPHIRE_BAND: {
        id: 'sapphire_band',
        name: 'Sapphire Band',
        level: 5,
        xp: 40,
        baseTime: 3000,
        inputItems: [
            { itemId: 'sapphire', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 }
        ],
        drops: [{ itemId: 'sapphire_band', weight: 1, quantity: 1 }],
        color: '#0f52ba',
        category: 'band'
    },
    EMERALD_BAND: {
        id: 'emerald_band',
        name: 'Emerald Band',
        level: 27,
        xp: 55,
        baseTime: 3500,
        inputItems: [
            { itemId: 'emerald', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 }
        ],
        drops: [{ itemId: 'emerald_band', weight: 1, quantity: 1 }],
        color: '#50c878',
        category: 'band'
    },
    RUBY_BAND: {
        id: 'ruby_band',
        name: 'Ruby Band',
        level: 43,
        xp: 70,
        baseTime: 4000,
        inputItems: [
            { itemId: 'ruby', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 }
        ],
        drops: [{ itemId: 'ruby_band', weight: 1, quantity: 1 }],
        color: '#e0115f',
        category: 'band'
    },
    DIAMOND_BAND: {
        id: 'diamond_band',
        name: 'Diamond Band',
        level: 56,
        xp: 85,
        baseTime: 4500,
        inputItems: [
            { itemId: 'diamond', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 }
        ],
        drops: [{ itemId: 'diamond_band', weight: 1, quantity: 1 }],
        color: '#b9f2ff',
        category: 'band'
    },
    ASTRYX_STONE_BAND: {
        id: 'astryx_stone_band',
        name: 'Astryx Stone Band',
        level: 72,
        xp: 100,
        baseTime: 5000,
        inputItems: [
            { itemId: 'astryx_stone', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 }
        ],
        drops: [{ itemId: 'astryx_stone_band', weight: 1, quantity: 1 }],
        color: '#9932cc',
        category: 'band'
    },
    ONYX_BAND: {
        id: 'onyx_band',
        name: 'Onyx Band',
        level: 90,
        xp: 120,
        baseTime: 5500,
        inputItems: [
            { itemId: 'onyx', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 }
        ],
        drops: [{ itemId: 'onyx_band', weight: 1, quantity: 1 }],
        color: '#353839',
        category: 'band'
    },
    // Pendants - gem + gold bar + spun fiber - Neck slot
    SAPPHIRE_PENDANT: {
        id: 'sapphire_pendant',
        name: 'Sapphire Pendant',
        level: 12,
        xp: 55,
        baseTime: 3500,
        inputItems: [
            { itemId: 'sapphire', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 },
            { itemId: 'spun_fiber', quantity: 1 }
        ],
        drops: [{ itemId: 'sapphire_pendant', weight: 1, quantity: 1 }],
        color: '#0f52ba',
        category: 'pendant'
    },
    EMERALD_PENDANT: {
        id: 'emerald_pendant',
        name: 'Emerald Pendant',
        level: 34,
        xp: 70,
        baseTime: 4000,
        inputItems: [
            { itemId: 'emerald', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 },
            { itemId: 'spun_fiber', quantity: 1 }
        ],
        drops: [{ itemId: 'emerald_pendant', weight: 1, quantity: 1 }],
        color: '#50c878',
        category: 'pendant'
    },
    RUBY_PENDANT: {
        id: 'ruby_pendant',
        name: 'Ruby Pendant',
        level: 50,
        xp: 85,
        baseTime: 4500,
        inputItems: [
            { itemId: 'ruby', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 },
            { itemId: 'spun_fiber', quantity: 1 }
        ],
        drops: [{ itemId: 'ruby_pendant', weight: 1, quantity: 1 }],
        color: '#e0115f',
        category: 'pendant'
    },
    DIAMOND_PENDANT: {
        id: 'diamond_pendant',
        name: 'Diamond Pendant',
        level: 63,
        xp: 100,
        baseTime: 5000,
        inputItems: [
            { itemId: 'diamond', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 },
            { itemId: 'spun_fiber', quantity: 1 }
        ],
        drops: [{ itemId: 'diamond_pendant', weight: 1, quantity: 1 }],
        color: '#b9f2ff',
        category: 'pendant'
    },
    ASTRYX_STONE_PENDANT: {
        id: 'astryx_stone_pendant',
        name: 'Astryx Stone Pendant',
        level: 80,
        xp: 115,
        baseTime: 5500,
        inputItems: [
            { itemId: 'astryx_stone', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 },
            { itemId: 'spun_fiber', quantity: 1 }
        ],
        drops: [{ itemId: 'astryx_stone_pendant', weight: 1, quantity: 1 }],
        color: '#9932cc',
        category: 'pendant'
    },
    ONYX_PENDANT: {
        id: 'onyx_pendant',
        name: 'Onyx Pendant',
        level: 95,
        xp: 135,
        baseTime: 6000,
        inputItems: [
            { itemId: 'onyx', quantity: 1 },
            { itemId: 'gold_bar', quantity: 1 },
            { itemId: 'spun_fiber', quantity: 1 }
        ],
        drops: [{ itemId: 'onyx_pendant', weight: 1, quantity: 1 }],
        color: '#353839',
        category: 'pendant'
    }
};

// Armor tier configurations
// baseHides = hides for 1.0x slot multiplier, goldPerHide = gold cost per hide used
const ARMOR_TIER_CONFIG = {
    1: {
        prefix: 'treated',
        name: 'Treated',
        hideId: 'treated_hide',
        baseHides: 3,
        goldPerHide: 25,
        baseTime: 4000,
        baseXp: 30,
        levelStart: 1,
        color: '#8B4513'
    },
    2: {
        prefix: 'green_wyrm',
        name: 'Green Wyrm',
        hideId: 'green_wyrm_hide',
        baseHides: 4,
        goldPerHide: 50,
        baseTime: 6000,
        baseXp: 60,
        levelStart: 15,
        color: '#2E8B57'
    },
    3: {
        prefix: 'blue_wyrm',
        name: 'Blue Wyrm',
        hideId: 'blue_wyrm_hide',
        baseHides: 5,
        goldPerHide: 100,
        baseTime: 8000,
        baseXp: 105,
        levelStart: 30,
        color: '#4169E1'
    },
    4: {
        prefix: 'red_wyrm',
        name: 'Red Wyrm',
        hideId: 'red_wyrm_hide',
        baseHides: 6,
        goldPerHide: 250,
        baseTime: 10000,
        baseXp: 175,
        levelStart: 50,
        color: '#DC143C'
    },
    5: {
        prefix: 'black_drake',
        name: 'Black Drake',
        hideId: 'black_drake_hide',
        baseHides: 8,
        goldPerHide: 500,
        baseTime: 12000,
        baseXp: 300,
        levelStart: 65,
        color: '#1C1C1C'
    },
    6: {
        prefix: 'void_drake',
        name: 'Void Drake',
        hideId: 'void_drake_hide',
        baseHides: 10,
        goldPerHide: 1000,
        baseTime: 15000,
        baseXp: 475,
        levelStart: 80,
        color: '#4B0082'
    }
};

// Armor slot configurations
// hideMult scales the base hides (larger pieces need more material)
const ARMOR_SLOT_CONFIG = {
    gloves: { name: 'Gauntlets', levelOffset: 0, xpMult: 0.8, hideMult: 0.5 },
    boots: { name: 'Boots', levelOffset: 2, xpMult: 0.85, hideMult: 0.6 },
    helm: { name: 'Helm', levelOffset: 4, xpMult: 0.9, hideMult: 0.8 },
    shoulders: { name: 'Vambraces', levelOffset: 6, xpMult: 1.0, hideMult: 0.9 },  // id kept 'shoulders' — see armor.js ARMOR_SLOTS note
    legguards: { name: 'Legguards', levelOffset: 8, xpMult: 1.1, hideMult: 1.0 },
    chestplate: { name: 'Chestplate', levelOffset: 10, xpMult: 1.2, hideMult: 1.2 }
};

// Generate armor recipes for a tier
function generateArmorRecipes(tier) {
    const tierConfig = ARMOR_TIER_CONFIG[tier];
    const recipes = {};

    for (const [slotId, slotConfig] of Object.entries(ARMOR_SLOT_CONFIG)) {
        const recipeId = `${tierConfig.prefix}_${slotId}`.toUpperCase();
        const itemId = `${tierConfig.prefix}_${slotId}`;

        // Calculate hides needed based on slot size (minimum 1)
        const hideQty = Math.max(1, Math.round(tierConfig.baseHides * slotConfig.hideMult));
        // Gold scales with hides used
        const goldCost = hideQty * tierConfig.goldPerHide;

        recipes[recipeId] = {
            id: itemId,
            name: `${tierConfig.name} ${slotConfig.name}`,
            level: tierConfig.levelStart + slotConfig.levelOffset,
            xp: Math.round(tierConfig.baseXp * slotConfig.xpMult),
            baseTime: tierConfig.baseTime,
            inputItems: [
                { itemId: tierConfig.hideId, quantity: hideQty }
            ],
            goldCost: goldCost,
            drops: [{ itemId: itemId, weight: 1, quantity: 1 }],
            color: tierConfig.color,
            slot: slotId,
            tier: tier
        };
    }

    return recipes;
}

// Generate all armor tiers
export const ARMOR_TREATED = generateArmorRecipes(1);
export const ARMOR_GREEN_WYRM = generateArmorRecipes(2);
export const ARMOR_BLUE_WYRM = generateArmorRecipes(3);
export const ARMOR_RED_WYRM = generateArmorRecipes(4);
export const ARMOR_BLACK_DRAKE = generateArmorRecipes(5);
export const ARMOR_VOID_DRAKE = generateArmorRecipes(6);

// Combined armor lookup by tier
export const ARMOR_BY_TIER = {
    1: ARMOR_TREATED,
    2: ARMOR_GREEN_WYRM,
    3: ARMOR_BLUE_WYRM,
    4: ARMOR_RED_WYRM,
    5: ARMOR_BLACK_DRAKE,
    6: ARMOR_VOID_DRAKE
};

// All armor recipes combined
export const ALL_ARMOR = {
    ...ARMOR_TREATED,
    ...ARMOR_GREEN_WYRM,
    ...ARMOR_BLUE_WYRM,
    ...ARMOR_RED_WYRM,
    ...ARMOR_BLACK_DRAKE,
    ...ARMOR_VOID_DRAKE
};

// Armor tier info for UI
export const ARMOR_TIERS = {
    1: { name: 'Treated', level: 1, color: '#8B4513' },
    2: { name: 'Green Wyrm', level: 15, color: '#2E8B57' },
    3: { name: 'Blue Wyrm', level: 30, color: '#4169E1' },
    4: { name: 'Red Wyrm', level: 50, color: '#DC143C' },
    5: { name: 'Black Drake', level: 65, color: '#1C1C1C' },
    6: { name: 'Void Drake', level: 80, color: '#4B0082' }
};

// ==================== MAGIC ARMOR ====================

// Magic armor tier configurations
// baseCloth = cloth for 1.0x slot multiplier, goldPerCloth = gold cost per cloth used
const MAGIC_ARMOR_TIER_CONFIG = {
    1: {
        prefix: 'linenweave',
        name: 'Linenweave',
        clothId: 'linenweave',
        baseCloth: 3,
        goldPerCloth: 20,
        baseTime: 3500,
        baseXp: 25,
        levelStart: 1,
        color: '#F5F5DC'
    },
    2: {
        prefix: 'silkweave',
        name: 'Silkweave',
        clothId: 'silkweave',
        baseCloth: 4,
        goldPerCloth: 40,
        baseTime: 5500,
        baseXp: 55,
        levelStart: 15,
        color: '#FFF8DC'
    },
    3: {
        prefix: 'aetherweave',
        name: 'Aetherweave',
        clothId: 'aetherweave',
        baseCloth: 5,
        goldPerCloth: 85,
        baseTime: 7500,
        baseXp: 95,
        levelStart: 30,
        color: '#87CEEB'
    },
    4: {
        prefix: 'runebound',
        name: 'Runebound',
        clothId: 'runebound_cloth',
        baseCloth: 6,
        goldPerCloth: 200,
        baseTime: 9500,
        baseXp: 160,
        levelStart: 50,
        color: '#9370DB'
    },
    5: {
        prefix: 'shadowweave',
        name: 'Shadowweave',
        clothId: 'shadowweave',
        baseCloth: 8,
        goldPerCloth: 425,
        baseTime: 11500,
        baseXp: 275,
        levelStart: 65,
        color: '#5A5A8F'
    },
    6: {
        prefix: 'voidweave',
        name: 'Voidweave',
        clothId: 'voidweave',
        baseCloth: 10,
        goldPerCloth: 850,
        baseTime: 14000,
        baseXp: 450,
        levelStart: 80,
        color: '#663399'
    }
};

// Magic armor slot configurations
// clothMult scales the base cloth (larger pieces need more material)
const MAGIC_ARMOR_SLOT_CONFIG = {
    gloves: { name: 'Wraps', levelOffset: 0, xpMult: 0.8, clothMult: 0.5 },
    boots: { name: 'Slippers', levelOffset: 2, xpMult: 0.85, clothMult: 0.6 },
    helm: { name: 'Hood', levelOffset: 4, xpMult: 0.9, clothMult: 0.8 },
    shoulders: { name: 'Mantle', levelOffset: 6, xpMult: 1.0, clothMult: 0.9 },
    legguards: { name: 'Leggings', levelOffset: 8, xpMult: 1.1, clothMult: 1.0 },
    chestplate: { name: 'Robe', levelOffset: 10, xpMult: 1.2, clothMult: 1.2 }
};

// Generate magic armor recipes for a tier
function generateMagicArmorRecipes(tier) {
    const tierConfig = MAGIC_ARMOR_TIER_CONFIG[tier];
    const recipes = {};

    for (const [slotId, slotConfig] of Object.entries(MAGIC_ARMOR_SLOT_CONFIG)) {
        const recipeId = `${tierConfig.prefix}_${slotId}`.toUpperCase();
        const itemId = `${tierConfig.prefix}_${slotId}`;

        // Calculate cloth needed based on slot size (minimum 1)
        const clothQty = Math.max(1, Math.round(tierConfig.baseCloth * slotConfig.clothMult));
        // Gold scales with cloth used
        const goldCost = clothQty * tierConfig.goldPerCloth;

        recipes[recipeId] = {
            id: itemId,
            name: `${tierConfig.name} ${slotConfig.name}`,
            level: tierConfig.levelStart + slotConfig.levelOffset,
            xp: Math.round(tierConfig.baseXp * slotConfig.xpMult),
            baseTime: tierConfig.baseTime,
            inputItems: [
                { itemId: tierConfig.clothId, quantity: clothQty }
            ],
            goldCost: goldCost,
            drops: [{ itemId: itemId, weight: 1, quantity: 1 }],
            color: tierConfig.color,
            slot: slotId,
            tier: tier
        };
    }

    return recipes;
}

// Generate all magic armor tiers
export const MAGIC_ARMOR_LINEN = generateMagicArmorRecipes(1);
export const MAGIC_ARMOR_SILK = generateMagicArmorRecipes(2);
export const MAGIC_ARMOR_ENCHANTED = generateMagicArmorRecipes(3);
export const MAGIC_ARMOR_RUNE = generateMagicArmorRecipes(4);
export const MAGIC_ARMOR_SHADOW = generateMagicArmorRecipes(5);
export const MAGIC_ARMOR_VOID = generateMagicArmorRecipes(6);

// Combined magic armor lookup by tier
export const MAGIC_ARMOR_BY_TIER = {
    1: MAGIC_ARMOR_LINEN,
    2: MAGIC_ARMOR_SILK,
    3: MAGIC_ARMOR_ENCHANTED,
    4: MAGIC_ARMOR_RUNE,
    5: MAGIC_ARMOR_SHADOW,
    6: MAGIC_ARMOR_VOID
};

// All magic armor recipes combined
export const ALL_MAGIC_ARMOR = {
    ...MAGIC_ARMOR_LINEN,
    ...MAGIC_ARMOR_SILK,
    ...MAGIC_ARMOR_ENCHANTED,
    ...MAGIC_ARMOR_RUNE,
    ...MAGIC_ARMOR_SHADOW,
    ...MAGIC_ARMOR_VOID
};

// Magic armor tier info for UI
export const MAGIC_ARMOR_TIERS = {
    1: { name: 'Linenweave', level: 1, color: '#F5F5DC' },
    2: { name: 'Silkweave', level: 15, color: '#FFF8DC' },
    3: { name: 'Aetherweave', level: 30, color: '#87CEEB' },
    4: { name: 'Runebound', level: 50, color: '#9370DB' },
    5: { name: 'Shadowweave', level: 65, color: '#5A5A8F' },
    6: { name: 'Voidweave', level: 80, color: '#663399' }
};

export default {
    JEWELRY,
    TOOLS,
    ARMOR_BY_TIER,
    ALL_ARMOR,
    ARMOR_TIERS,
    MAGIC_ARMOR_BY_TIER,
    ALL_MAGIC_ARMOR,
    MAGIC_ARMOR_TIERS
};